import { defineStore } from 'pinia';
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, resolveLocale } from '../locales';

const STORAGE_KEY = 'preferredLocale';

function readStoredLocale() {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.localStorage.getItem(STORAGE_KEY);
}

function persistLocale(locale) {
  if (typeof window === 'undefined') {
    return;
  }
  window.localStorage.setItem(STORAGE_KEY, locale);
}

export const useLocaleStore = defineStore('locale', {
  state: () => ({
    currentLocale: DEFAULT_LOCALE
  }),
  getters: {
    availableLocales: () => SUPPORTED_LOCALES
  },
  actions: {
    /**
     * Determine the initial locale using stored preference, browser language,
     * and default fallback. Returns the resolved locale.
     *
     * @returns {string}
     */
    initializeLocale() {
      const storedLocale = readStoredLocale();
      const browserLocale =
        typeof navigator !== 'undefined' ? navigator.language || navigator.languages?.[0] : null;

      const resolved = resolveLocale(storedLocale || browserLocale || DEFAULT_LOCALE);

      this.currentLocale = resolved;
      persistLocale(resolved);
      return resolved;
    },
    /**
     * Update the current locale and persist the selection.
     *
     * @param {string} localeCandidate
     */
    setLocale(localeCandidate) {
      const resolved = resolveLocale(localeCandidate);
      this.currentLocale = resolved;
      persistLocale(resolved);
    }
  }
});
